"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuidesDataClient = void 0;
var axios_1 = __importDefault(require("axios"));
var GuidesDataClient = /** @class */ (function () {
    function GuidesDataClient(baseUrl) {
        var _this = this;
        if (baseUrl === void 0) { baseUrl = undefined; }
        this.baseUrl = baseUrl;
        this.getGuidesMainData = function (municipalities) {
            var _a;
            return _this.getRequest(((_a = _this.baseUrl) !== null && _a !== void 0 ? _a : '') + "/api/guides", { municipalities: municipalities });
        };
        this.getGuidesProgressState = function (municipalities) {
            var _a;
            return _this.getRequest(((_a = _this.baseUrl) !== null && _a !== void 0 ? _a : '') + "/api/guides/progress", { municipalities: municipalities });
        };
        this.updateResponse = function (itemId, municipalitySlug, checked, note) {
            // rails wants snake_case
            return _this.putRequest("/api/guides/items/" + itemId, { municipality_slug: municipalitySlug, checked: checked, note: note });
        };
        this.getRequest = function (url, params) {
            return axios_1.default.get(url, {
                params: params,
                headers: { "Accept": "application/json" }
            }).then(function (r) { return r.data; }).catch(function (e) { return console.error(e); });
        };
        this.putRequest = function (url, params) {
            return axios_1.default.put(url, {
                params: params,
                headers: { "Accept": "application/json" }
            }).then(function (r) { return r.data; }).catch(function (e) { return console.error(e); });
        };
    }
    return GuidesDataClient;
}());
exports.GuidesDataClient = GuidesDataClient;
